import React from 'react';
import Image from 'next/image';

import Card from '../Card/Card';

import styles from './MeetBlock.module.scss';
import Props from './MeetBlock.props';

const MeetBlock = ({ thumbnail, title, description, className, url }: Props) => {
  return (
    <Card innerClassName={styles.Card} className={className} href={url}>
      <div className={styles.MeetBlock}>
        <div className={styles.Thumbnail}>
          <Image src={thumbnail} alt="" quality={60} layout="fill" />
        </div>
        <div className={styles.Content}>
          <h3 className={styles.Title}>{title}</h3>
          <p className={styles.Description}>{description}</p>
        </div>
      </div>
    </Card>
  );
};

export default MeetBlock;
